import { render, staticRenderFns } from "./white.vue?vue&type=template&id=683f9332&"
import script from "./white.vue?vue&type=script&lang=js&"
export * from "./white.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('683f9332')) {
      api.createRecord('683f9332', component.options)
    } else {
      api.reload('683f9332', component.options)
    }
    module.hot.accept("./white.vue?vue&type=template&id=683f9332&", function () {
      api.rerender('683f9332', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/formSys/white.vue"
export default component.exports